import * as React from "react";
import {
  Alert,
  Box,
  Button,
  Card,
  CircularProgress,
  Stack,
  Typography,
} from "@mui/material";
import ArrowBackRoundedIcon from "@mui/icons-material/ArrowBackRounded";
import { useNavigate, useSearchParams } from "react-router-dom";
import { loginService } from "../../services/loginService";
import { COLORS } from "../../theme/theme-options";

const GoogleOAuthCallbackPage: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [error, setError] = React.useState<string | null>(null);

  React.useEffect(() => {
    const code = searchParams.get("code");
    if (!code) {
      setError("Missing grant code.");
      return;
    }

    const redeem = async () => {
      try {
        await loginService.redeemGoogleGrantCode(code);
        navigate("/dashboards", { replace: true });
      } catch (redeemError) {
        const message =
          redeemError instanceof Error
            ? redeemError.message
            : "Failed to redeem google grant code.";
        setError(message);
      }
    };

    void redeem();
  }, [navigate, searchParams]);

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "grid",
        placeItems: "center",
        p: 2,
        background:
          "radial-gradient(circle at 20% 20%, rgba(56,189,248,0.18) 0%, rgba(6,13,26,1) 45%), #060d1a",
      }}
    >
      <Card variant="glass" sx={{ width: "100%", maxWidth: 460, p: 3 }}>
        <Stack spacing={2}>
          <Typography sx={{ fontSize: 22, fontWeight: 800, color: COLORS.grey[100] }}>
            Google OAuth Callback
          </Typography>

          {!error && (
            <Stack direction="row" spacing={1.2} alignItems="center">
              <CircularProgress size={18} />
              <Typography sx={{ color: COLORS.grey[400] }}>
                Redeeming authorization code...
              </Typography>
            </Stack>
          )}

          {error && (
            <>
              <Alert severity="error">{error}</Alert>
              <Button
                variant="outlined"
                startIcon={<ArrowBackRoundedIcon fontSize="small" />}
                onClick={() => {
                  navigate("/login", { replace: true });
                }}
              >
                Back to login
              </Button>
            </>
          )}
        </Stack>
      </Card>
    </Box>
  );
};

export default GoogleOAuthCallbackPage;

